export const BOOK_STATUS_INVALID = "INVALID";
export const BOOK_STATUS_STARTED = "STARTED";
export const BOOK_STATUS_UPLOADED = "UPLOADED";
export const BOOK_STATUS_PUBLISHED = "PUBLISHED";
export const BOOK_STATUS_CANCELLED = "CANCELLED";

export const HELP_HOME = "home";

export const HELP_MAP = {
  "/publisher/digibooks/auth/sign-in":
    "https://www.digibooks4all.com/digibooks4allUserManual/HTML/3-login.html",
  "/publisher/digibooks/auth/forgot-password":
    "https://www.digibooks4all.com/digibooks4allUserManual/HTML/15-forgot-password.html",
  home: "https://www.digibooks4all.com/digibooks4allUserManual/",
};
